import clsx from "clsx";
import { Search } from "../svg/Wallet/Wallet";

function CustomInput({
  placeholder,
  type,
  disable,
  inputLabel,
  inputLabelError,
  value,
  leadingIcon,
  trailingIcon,
  onclick,
  className,
  required,
  name,
  autoComplete,
  onchange,
  helper,
  search,
}) {
  return (
    <div className="relative">
      {inputLabel && (
        <span
          className={clsx(
            "absolute left-5 text-[12px] bg-white text-neutral-600 px-1",
            inputLabelError && "!text-red-500"
          )}
        >
          {inputLabel}
        </span>
      )}
      {leadingIcon && (
        <span className="absolute top-[23px] left-[12px] cursor-pointe">
          {leadingIcon}
        </span>
      )}
      <input
        className={clsx(
          search && "pl-10",
          trailingIcon && "pr-[42px]",
          leadingIcon && "pl-[35px]",
          disable && "text-neutral-420",
          "py-2 px-4 w-full h-[50px] my-2 text-base shadow rounded-full border border-[#00000050] focus:border-2 focus:border-primary-navy focus-visible:outline-none placeholder:text-[14px]",
          className
        )}
        name={name}
        value={value}
        placeholder={placeholder}
        type={type}
        disabled={disable}
        autoComplete={autoComplete}
        required={required}
        onChange={onchange}
      />
      {trailingIcon && (
        <span
          onClick={onclick}
          className="absolute top-[23px] right-[16px] cursor-pointer"
        >
          {trailingIcon}
        </span>
      )}
      {helper && (
        <p className={clsx("text-[12px] leading-4 text-red-500 pl-2")}>
          {helper}
        </p>
      )}
      {search && <Search className="absolute top-[20px] w-5 h-5 left-4" />}
    </div>
  );
}

export default CustomInput;
